// src/config/pricing.js
// Single source of truth for all plan prices.
// Used by LandingPage.js, ProfilePage.jsx, and anywhere else prices are displayed.
// Display only: the amounts charged are the Stripe prices / Razorpay plans the
// backend points at (STRIPE_PRICE_ID_* / RAZORPAY_PLAN_ID_*). Change both together.

export const TRIAL_DAYS = 14;

export const PRICES = {
  usd: {
    individual: {
      monthly:   '$19',
      yearly:    '$180',
      saveLabel: 'Save $48/yr',
      period_mo: '/mo',
      period_yr: '/yr',
    },
    teams: {
      monthly:   '$69',
      yearly:    '$690',
      saveLabel: 'Save $138/yr · 5 seats included',
      period_mo: '/mo',
      period_yr: '/yr',
    },
  },
  inr: {
    individual: {
      monthly:   '₹899',
      yearly:    '₹8,499',
      saveLabel: 'Save ₹2,289/yr',
      period_mo: '/mo',
      period_yr: '/yr',
    },
    teams: {
      monthly:   '₹2,999',
      yearly:    '₹29,999',
      saveLabel: 'Save ₹5,989/yr · 5 seats included',
      period_mo: '/mo',
      period_yr: '/yr',
    },
  },
};

// Extra per-seat price shown in Teams card features list
export const EXTRA_SEAT_PRICE = {
  usd: '$14',
  inr: '₹599',
};

// Extra per-seat price shown in yearly toggle (lump sum per extra seat/yr)
export const EXTRA_SEAT_YEARLY = {
  usd: '$140',
  inr: '₹5,999',
};
